
/* Generated apis ---------------------- */
import { to } from 'react-lib/utils'
import BaseService from  'react-lib/apis/services/BaseService'
import config from '../../config/config'
import MiscellaneousOrderSerializer from '../types/MiscellaneousOrderSerializer_core'
import { data } from 'jquery'


const HOST = `${config.API_HOST}`
/* ['generics.RetrieveUpdateDestroyAPIView'] */
/* params:  */
/* data:  */
const MiscellaneousOrderDetail :
{
  retrieve: ({pk, params, apiToken, extra}:
             { pk: any,
                params?: any,
                apiToken?: any,
                extra?: any,
            }) => any,
  delete: ({pk, params, data, apiToken, extra}:
             { pk: any,
                params?: any,
                data?: any;
                apiToken?: any,
                extra?: any,
            }) => any,
  update:   ({pk, params, data, apiToken, extra}:
             { pk: any,
                params?: any,
                data?: MiscellaneousOrderSerializer,
                apiToken?: any,
                extra?: any,
            }) => any,
  patch:    ({pk, params, data, apiToken, extra}:
             { pk: any,
                params?: any,
                data?: MiscellaneousOrderSerializer,
                apiToken?: any,
                extra?: any,
            }) => any,
} =
{
  retrieve: async ({pk, params, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.get(`${HOST}/apis/core/miscellaneous-order/${pk}/`,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },

  delete: async ({pk, params, data, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.delete(`${HOST}/apis/core/miscellaneous-order/${pk}/`,
      { params: params ? { ...params } : {},
      data: data ? data : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },

  update: async ({pk, params, data, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.put(`${HOST}/apis/core/miscellaneous-order/${pk}/`,
      data,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },

  patch: async ({pk, params, data, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.patch(`${HOST}/apis/core/miscellaneous-order/${pk}/`,
      data,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },
}

export default MiscellaneousOrderDetail

